export const FETCH_ICONIC_STORIES_TYPE = 'ICONIC_STORIES';
export const ICONIC_STORIES_FILTER_CHANGED = 'ICONIC_STORIES_FILTER_CHANGED';

export const fetchIconicStoriesActionCreator = (filterId, promise) => ({
  meta: {
    filterId,
  },
  type: FETCH_ICONIC_STORIES_TYPE,
  payload: promise,
});

export const iconicStoriesFilterChangedCreator = (sliceId, filterName) => ({
  meta: { sliceId },
  type: ICONIC_STORIES_FILTER_CHANGED,
  payload: { filterName },
});
